import { type FC } from 'react';
import { isEqual } from 'lodash-es';

import { type Conflict } from '@editor2/types/conflict';
import { sanitizeAttributeName } from '@editor2/components/CourseChangesDiff/helpers';
import {
	createReorderConflict,
	getValue
} from '@editor2/components/ConflictResolutionModal/helpers';
import { REORDER_ALLOW_LIST } from '@editor2/types/reorderAllowList';
import InitialIncomingReorderView from './InitialIncomingReorder';
import IncomingChangesDivider from '../common/IncomingChangesDivider';
import ConflictDiffView from '../common/ConflictDiffView';
import DeletedEntityView from '../common/DeletedEntity';

interface Props {
	conflict: Conflict;
	courseId: number;
	deletedEntityName: string;
	showButton: boolean;
}

const DeletedModifiedView: FC<Props> = (props) => {
	const { conflict, courseId, deletedEntityName, showButton } = props;

	return (
		<div>
			<DeletedEntityView name={deletedEntityName} />

			<IncomingChangesDivider courseId={courseId} conflict={conflict} showButton={showButton} />

			{Object.keys(conflict.incoming).map((attribute, index) => {
				if (isEqual(conflict.initial[attribute], conflict.incoming[attribute])) return;

				return (
					<div key={index}>
						<div>{sanitizeAttributeName(attribute)}</div>

						{!REORDER_ALLOW_LIST.includes(attribute) && (
							<ConflictDiffView
								oldValue={getValue(conflict.initial, attribute)}
								newValue={getValue(conflict.incoming, attribute)}
							/>
						)}

						{REORDER_ALLOW_LIST.includes(attribute) && (
							<InitialIncomingReorderView
								conflict={createReorderConflict(conflict, attribute)}
								courseId={courseId}
							/>
						)}
					</div>
				);
			})}
		</div>
	);
};

export default DeletedModifiedView;
